import { TreatmentDesignRevisionLiability } from '../treatment-design-revision-judgement';

/** Create/update payload for a revision reason. */
export interface DesignRevisionReasonEditModel {
    readonly content: string;
    /** Null means the reason is offered for every treatment type. */
    readonly treatmentTypeOriginalId?: number | null;
    readonly revisionLiability: TreatmentDesignRevisionLiability;
    readonly isActive: boolean;
    readonly displayOrder: number;
}
